import React, { useEffect, useState, useMemo } from 'react'

const useOnScreen = (ref: React.RefObject<HTMLDivElement>) => {
  const [isIntersecting, setIntersecting] = useState(false)
  const observer = useMemo(() => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting)), [])

  useEffect(() => {
    if (ref?.current) {
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [observer, ref])

  return isIntersecting
}

export default useOnScreen
